import React from 'react';
import styled, { css } from 'styled-components';
const commonCss = css `
	bottom: 12px;
	height: 34px; // some communities have extra styles
	position: absolute;
	right: 18px;
`;
const StyledMobileLogoImage = styled.img `
	${commonCss}
	display: none;
	@media (max-width: 480px) {
		display: inline;
	}
`;
const StyledDesktopLogoImage = styled.img `
	${commonCss}
	display: none;
	@media (min-width: 481px) {
		display: inline;
	}
`;
// Add logic to include showing the mobile version when a rail variant will be available for the affiliate unit
export default function AffiliateLogoImage({ desktopLogo, mobileLogo, className, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMobileLogoImage, { className: className, src: mobileLogo }),
        React.createElement(StyledDesktopLogoImage, { className: className, src: desktopLogo })));
}
